import { gql } from 'graphql-request';

export const ADD_TO_SHELF_MUTATION = gql`
  mutation AddToShelf($input: AddToShelfInput!) {
    addToShelf(input: $input) {
      id
    }
  }
`;

export const REMOVE_FROM_SHELF_MUTATION = gql`
  mutation RemoveFromShelf($input: RemoveFromShelfInput!) {
    removeFromShelf(input: $input) {
      success
    }
  }
`;
